class Module {
    constructor() {
        let toggleModel = window.toggles;

        if (toggleModel === null || toggleModel === undefined) {
            toggleModel = {};
        }
        this.toggles = toggleModel;
    }
    load() {
        return this.toggles;
    }
    isEnabled(toggleName) {
        return !!this.toggles[toggleName];
    }
}

export default new Module();
